export const educationData = [
    {
        id: 1,
        title: "Bachelor of Science (B.Sc.) in Computer Science and Engineering",
        school: "Bangladesh University of Business and Technology (BUBT)",
        year: "2018 – 2022",
    },
    {
        id: 2,
        title: "Higher Secondary Certificate (HSC)",
        school: "Dhunat Government N.U. Pilot Model College, Bogura",
        year: "2015 – 2017",
    },
    {
        id: 3,
        title: "Secondary School Certificate (SSC)",
        school: "Dhunat Adarsha High School, Bogura",
        year: "2010 – 2015",
    },
];